function replaceAll(str, find, replace) {
  return str.replace(new RegExp(find, 'g'), replace);
}

/*
  claimOrRefund: Swaps any variation of claim for refund

  1. Parse URL to see if it contains .net or .insure
  2. .net signifies that the Claims Form is being hit from outside the U.S.
  3. .insure signifies that the Claims Form is being hit from inside the U.S.
  4. Depending on this we will change Claim to Refund ( Claim is domestic / Refund is international)

*/

const replaceMarkelToJsv = (value) => {
  const URL = window.location.href;
  const isRefund = URL.includes('net');
  const verbiageTranslations = {
    claim: 'refund request',
    'Premium Cost': 'Refund Protection Cost',
    premium: 'refund protection cost',
    insurance: 'programme',
    policy: 'refund protection',
    policies: 'certificates',
    policyholder: 'ticketholder',
    peril: 'listed refund reason in the terms and conditions',
  };
  let sentence = value;
  if (isRefund) {
    Object.keys(verbiageTranslations).forEach((word) => {
      const caseInsensitiveRegex = new RegExp(word, 'gi');
      if (sentence.search(caseInsensitiveRegex) >= 0) {
        const jsvWord = verbiageTranslations[word];
        const firstUpperCaseJsv = jsvWord.charAt(0).toUpperCase() + jsvWord.slice(1);
        const firstUpperCaseMarkel = word.charAt(0).toUpperCase() + word.slice(1);
        sentence = replaceAll(sentence, word.toUpperCase(), jsvWord.toUpperCase());
        sentence = replaceAll(sentence, word.toLowerCase(), jsvWord.toLowerCase());
        sentence = replaceAll(sentence, firstUpperCaseMarkel, firstUpperCaseJsv);
      }
    });
  }
  return sentence;
};

export default {
  replaceMarkelToJsv,
};
